'use client';
import Button from '@/components/Button';
import { BootstrapContext, ToastContext } from '@/pagesComponents/Layout';
import { useContext, useEffect, useState } from 'react';

const Toast = ({ id, message, type }) => {
  const [colorClass, setColorClass] = useState('bg-primary');
  const bootstrap = useContext(BootstrapContext);
  const setColor = (type) => {
    switch (type) {
      case 'success':
        return 'bg-success';
      case 'error':
        return 'bg-danger';
      case 'info':
        return 'bg-info';
      case 'warning':
        return 'bg-warning';
      default:
        return 'bg-primary';
    }
  };
  useEffect(() => {
    const newColor = setColor(type);
    setColorClass(newColor);
  }, [type, message]);
  useEffect(() => {
    const toastEl = document.getElementById('default-toast');
    if (!bootstrap) {
      console.warn('Bootstrap context is not available.');
      return; // Exit if bootstrap is not available
    }
    window.toastInstance = bootstrap.Toast.getOrCreateInstance(toastEl);
  }, [bootstrap]);
  return (
    <div
      id={id || 'default-toast'}
      className={`toast align-items-center text-white ${colorClass} border-0 position-fixed fixed-top fixed-right`}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div className="d-flex">
        <div className="toast-body">{message}</div>
        <Button
          type="button"
          className="btn-close btn-close-white me-2 m-auto"
          data-bs-dismiss="toast"
          aria-label="Close"
        ></Button>
      </div>
    </div>
  );
};

export default Toast;

export const TestToast = () => {
  const updateToast = useContext(ToastContext);
  const toastInfo = {
    message: 'This is a test',
    type: 'success',
  };
  const showToast = () => {
    updateToast(toastInfo);
    setTimeout(() => {
      const toast = document.getElementById('default-toast');
      /* eslint-disable */
      const toastInstance = bootstrap.Toast.getOrCreateInstance(toast);
      toastInstance.show();
    }, 100);
  };

  return (
    <Button className={'btn btn-secondary'} onClick={() => showToast()}>
      {' '}
      Test Toast
    </Button>
  );
};
